import { IonLoading } from '@ionic/react'
import React from 'react'
import { PasswordChange } from '..'
import { useGetMe } from '../../../modules/me'

export const PagePasswordChange = () => {
  const { user } = useGetMe()
  return user ? <PasswordChange user={user} /> : <IonLoading isOpen={true} />
}
